var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "mainpage",
      class: _vm.videoFlag ? "main-page" : "main-page main-pages",
      attrs: { id: "main-parent" }
    },
    [
      _c("div", { staticClass: "top-title" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticStyle: { width: "200px" } },
          [
            _c(
              "marquee",
              {
                attrs: {
                  behavior: "scroll",
                  width: "500",
                  loop: "-1",
                  scrollamount: "4"
                }
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.inform ||
                      "【限时福利】即日起***时间，转发视频并集赞，就有机会成为飞鹤品鉴之星，赢千元大奖，赶快上车哦~"
                  )
                )
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { class: _vm.videoFlag ? "header" : "header headers" }, [
        _c(
          "div",
          { class: _vm.videoFlag ? "video-box" : "video-box video-boxs" },
          [
            _c("video-player", {
              attrs: { isOpenShare: _vm.isOpenShare || _vm.deleteonoff },
              on: { DOMFLAG: _vm.DOMFLAG }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.videoFlag
        ? _c(
            "div",
            {
              ref: "commentlistrefs",
              class: _vm.firstFlag
                ? "comment-list comment-lists"
                : "comment-list",
              attrs: { id: "main" }
            },
            [
              _c("div", { staticClass: "tab-top" }, [
                _c(
                  "div",
                  { staticClass: "tab-left" },
                  [
                    _vm._l(_vm.coverimg, function(item, index) {
                      return _c("img", {
                        key: index,
                        attrs: { src: item, alt: "" }
                      })
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.numberPeople > 0,
                            expression: "numberPeople > 0"
                          }
                        ]
                      },
                      [_vm._v(_vm._s(_vm.numberPeople) + "人参与")]
                    )
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.acquisitionTime !== 3
                  ? _c("div", { staticClass: "tab-right" }, [
                      _c("img", {
                        attrs: {
                          src:
                            _vm.condition !== 0
                              ? require("../assets/img/bangdan.png")
                              : require("../assets/img/canyu.png")
                        },
                        on: { click: _vm.determine }
                      })
                    ])
                  : _c("div", { staticClass: "tab-right" }, [
                      _c("img", {
                        attrs: { src: require("../assets/img/bangdan.png") },
                        on: { click: _vm.determine }
                      })
                    ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "tab-all" }, [
                _c(
                  "div",
                  {
                    staticClass: "tab-item",
                    class: { "tab-active": _vm.publicParams.currentTab == 1 },
                    on: {
                      click: function($event) {
                        return _vm.tabchange(1)
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "tab-item-text" }, [
                      _vm._v(
                        "\n                  全部讨论\n                  "
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "tab-textNum" }, [
                        _vm._v(
                          _vm._s(
                            _vm.tranNumber(_vm.totalObj.allComments || 0, 1)
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("i")
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "tab-item",
                    class: { "tab-active": _vm.publicParams.currentTab == 2 },
                    on: {
                      click: function($event) {
                        return _vm.tabchange(2)
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "tab-item-text" }, [
                      _vm._v(
                        "\n                  我的讨论\n                  "
                      ),
                      _c("span", { staticClass: "tab-textNum" }, [
                        _vm._v(
                          _vm._s(_vm.tranNumber(_vm.commentList.length || 0, 1))
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("i")
                  ]
                ),
                _vm._v(" "),
                _c("p", { staticClass: "tab-item-zan" }, [
                  _vm._v("集星" + _vm._s(_vm.tranNumber(_vm.likes || 0, 1)))
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.list.length > 0 || _vm.commentList.length > 0,
                      expression: "list.length > 0 || commentList.length > 0"
                    }
                  ],
                  staticClass: "list"
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isHeart,
                          expression: "isHeart"
                        }
                      ],
                      staticClass: "redheart"
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: require("../assets/img/redheart.gif"),
                          alt: ""
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "md-scroll-view",
                    {
                      ref: "scrollView",
                      attrs: { "scrolling-x": false, "auto-reflow": true },
                      on: {
                        refreshing: _vm.$_onRefresh,
                        "end-reached": _vm.$_onEndReached
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "refresh",
                            fn: function(ref) {
                              var scrollTop = ref.scrollTop
                              var isRefreshActive = ref.isRefreshActive
                              var isRefreshing = ref.isRefreshing
                              return _c("md-scroll-view-refresh", {
                                attrs: {
                                  "scroll-top": scrollTop,
                                  "is-refreshing": isRefreshing,
                                  "is-refresh-active": isRefreshActive
                                }
                              })
                            }
                          }
                        ],
                        null,
                        false,
                        1645618310
                      )
                    },
                    [
                      _vm._v(" "),
                      _vm.publicParams.currentTab == 2 &&
                      _vm.commentList.length >= 0
                        ? _c("div", { staticClass: "my-comment-list" }, [
                            _c(
                              "ul",
                              { staticClass: "my-list" },
                              [
                                _vm._l(_vm.commentList, function(item) {
                                  return [
                                    _c(
                                      "li",
                                      { key: item.id, staticClass: "item" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "item-title" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "item-time" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "username-con"
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src:
                                                          item.coverImg ||
                                                          require("../assets/img/default-coverimg.png"),
                                                        alt: ""
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "username"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.nickName ||
                                                              "用户" +
                                                                item.openId.substring(
                                                                  item.openId
                                                                    .length - 6
                                                                )
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm.TimeDifference(
                                                      item.createTime,
                                                      _vm.currentdate
                                                    )
                                                  ) +
                                                  "\n                                        "
                                              ),
                                              item.isCheck != 1
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass: "delete-btn",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.deleteMessage(
                                                            item.id
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [_vm._v("删除")]
                                                  )
                                                : _vm._e()
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          { staticClass: "comment-content" },
                                          [
                                            item.isSift == 1
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "sift-comment"
                                                  },
                                                  [_vm._v("精品")]
                                                )
                                              : _vm._e(),
                                            _vm._v(_vm._s(item.commentContent))
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("p", { staticClass: "check-tips" }, [
                                          item.isCheck == 0
                                            ? _c("span", [
                                                _vm._v(
                                                  "您的故事已提交，1个工作日内会完成审核，请耐心等待！"
                                                )
                                              ])
                                            : item.isCheck == 1
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass: "isCheck-success"
                                                },
                                                [
                                                  item.isSift == 1
                                                    ? _c(
                                                        "span",
                                                        { staticClass: "sift" },
                                                        [
                                                          _vm._v(
                                                            "恭喜您，您与我们的故事已入选精品讨论！"
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            : item.isCheck == 2
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass: "isCheck-faild"
                                                },
                                                [
                                                  _vm._v(
                                                    "您的故事未通过审核，请删除！"
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ])
                                      ]
                                    )
                                  ]
                                })
                              ],
                              2
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.list.length > 0 && _vm.publicParams.currentTab == 1
                        ? _c(
                            "ul",
                            { staticClass: "all-comment-list" },
                            [
                              _vm._l(_vm.list, function(item) {
                                return [
                                  _c(
                                    "li",
                                    {
                                      key: item.id,
                                      staticClass: "all-comment-item"
                                    },
                                    [
                                      _c("div", { staticClass: "name" }, [
                                        _c(
                                          "div",
                                          { staticClass: "username-con" },
                                          [
                                            _c("img", {
                                              attrs: {
                                                src:
                                                  item.coverImg ||
                                                  require("../assets/img/default-coverimg.png"),
                                                alt: ""
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "username" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    item.nickName ||
                                                      "用户" +
                                                        item.openId.substring(
                                                          item.openId.length - 6
                                                        )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "item-time" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.TimeDifference(
                                                  item.createTime,
                                                  _vm.currentdate
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        { staticClass: "comment-content" },
                                        [
                                          item.isSift
                                            ? _c(
                                                "span",
                                                { staticClass: "sift-comment" },
                                                [_vm._v("精品")]
                                              )
                                            : _vm._e(),
                                          _vm._v(_vm._s(item.commentContent))
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              })
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.publicParams.currentTab == 1
                        ? _c("md-scroll-view-more", {
                            staticClass: "md-scroll-more",
                            attrs: {
                              slot: "more",
                              "is-finished": _vm.isFinished,
                              "finished-text": "--已经是底线了哦--"
                            },
                            slot: "more"
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.publicParams.currentTab == 2
                        ? _c("md-scroll-view-more", {
                            staticClass: "md-scroll-more1",
                            attrs: {
                              slot: "more",
                              "is-finished": _vm.isFinished,
                              "finished-text": "---已经到底---"
                            },
                            slot: "more"
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.publicParams.currentTab == 2
                        ? _c("md-scroll-view-more", {
                            staticClass: "md-scroll-more2",
                            attrs: {
                              slot: "more",
                              "is-finished": _vm.isFinished,
                              "finished-text": "最多评论50条"
                            },
                            slot: "more"
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.hasGetData &&
              _vm.list.length <= 0 &&
              _vm.publicParams.currentTab == 1
                ? _c("div", { staticClass: "no-data-tip" }, [
                    _c("img", {
                      attrs: {
                        src: require("../assets/img/no-data.png"),
                        alt: "没数据"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.publicParams.currentTab == 1,
                            expression: "publicParams.currentTab == 1"
                          }
                        ]
                      },
                      [_vm._v("留下您的故事，让我们一起倾听您的经历。")]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.hasGetData &&
              _vm.commentList.length <= 0 &&
              _vm.publicParams.currentTab == 2
                ? _c("div", { staticClass: "no-data-tip" }, [
                    _c("img", {
                      attrs: {
                        src: require("../assets/img/no-data.png"),
                        alt: "没数据"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.publicParams.currentTab == 2,
                            expression: "publicParams.currentTab == 2"
                          }
                        ]
                      },
                      [_vm._v("留下您的故事，分享您的心得。")]
                    )
                  ])
                : _vm._e()
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.videoFlag && _vm.acquisitionTime == 1
        ? _c("div", { staticClass: "footer" }, [
            _c("div", { staticClass: "footer" }, [
              _c("div", { staticClass: "btns" }, [
                _c(
                  "p",
                  {
                    staticClass: "share-btn",
                    on: {
                      click: function($event) {
                        return _vm.onSharePage(true)
                      }
                    }
                  },
                  [
                    _c("span"),
                    _vm._v(" "),
                    _c("i", [
                      _vm._v(_vm._s(_vm.tranNumber(_vm.totalObj.share || 0, 1)))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass: "fabulous-btn",
                    class: { isCollect: _vm.totalObj.isCollect },
                    on: {
                      click: function($event) {
                        return _vm.mediaRecord()
                      }
                    }
                  },
                  [
                    _c("span"),
                    _vm._v(" "),
                    _c("i", [
                      _vm._v(
                        _vm._s(_vm.tranNumber(_vm.totalObj.collect || 0, 1))
                      )
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "showpopup-btn",
                  attrs: { id: "comment-childs" },
                  on: {
                    click: function($event) {
                      return _vm.showPopUp("bottom")
                    }
                  }
                },
                [_vm._v("留下您的故事...")]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isPopupShow
        ? _c(
            "div",
            { staticClass: "comment-box", attrs: { id: "comment-child" } },
            [
              _c("div", { staticClass: "comment-container" }, [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.commentContent,
                      expression: "commentContent"
                    }
                  ],
                  ref: "commentInput",
                  staticClass: "comment-input",
                  attrs: {
                    name: "",
                    id: "",
                    maxlength: "300",
                    placeholder: "留下您的故事..."
                  },
                  domProps: { value: _vm.commentContent },
                  on: {
                    blur: _vm.hidefn,
                    focus: function($event) {
                      return _vm.getfouce($event)
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.commentContent = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "comment-len" }, [
                  _vm._v(
                    _vm._s(
                      _vm.commentContent.length >= 300
                        ? 0
                        : 300 - _vm.commentContent.length
                    )
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "comment-footer" }, [
                _c(
                  "p",
                  {
                    staticClass: "comment-btn",
                    class: { disabled: !_vm.commentContent.trim() },
                    attrs: { id: "comment-btn" },
                    on: {
                      click: function($event) {
                        _vm.commentContent.trim() ? _vm.insertMessage() : ""
                      }
                    }
                  },
                  [_vm._v("发送")]
                )
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.videoFlag && _vm.acquisitionTime !== 3
        ? _c("hover-button", {
            attrs: {
              acquisitionTime: _vm.acquisitionTime,
              condition: _vm.condition
            },
            on: { isPhoneShow: _vm.isPhoneShow }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("share-page", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isOpenShare,
            expression: "isOpenShare"
          }
        ],
        ref: "sharePage",
        on: { closeSharePage: _vm.onSharePage }
      }),
      _vm._v(" "),
      _c(
        "md-popup",
        {
          staticClass: "md-popups",
          attrs: { "mask-closable": false },
          model: {
            value: _vm.isPopupPhoneShow,
            callback: function($$v) {
              _vm.isPopupPhoneShow = $$v
            },
            expression: "isPopupPhoneShow"
          }
        },
        [
          _c("div", { staticClass: "register-box" }, [
            _c(
              "div",
              { staticClass: "register-info" },
              [
                _c(
                  "md-input-item",
                  {
                    ref: "input0",
                    staticClass: "register-item",
                    attrs: {
                      title: "",
                      placeholder: "姓名",
                      type: "text",
                      maxlength: 10
                    },
                    model: {
                      value: _vm.registerinfo.name,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.registerinfo,
                          "name",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "registerinfo.name"
                    }
                  },
                  [
                    _c("span", {
                      staticClass: "name-icon",
                      attrs: { slot: "left" },
                      slot: "left"
                    })
                  ]
                ),
                _vm._v(" "),
                _c("p", { staticClass: "register-item register-item-native" }, [
                  _c("span", { staticClass: "phone-icon" }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.registerinfo.phone,
                        expression: "registerinfo.phone"
                      }
                    ],
                    attrs: {
                      type: "tel",
                      placeholder: "手机号",
                      maxlength: "11"
                    },
                    domProps: { value: _vm.registerinfo.phone },
                    on: {
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.registerinfo,
                            "phone",
                            $event.target.value
                          )
                        },
                        function($event) {
                          _vm.registerinfo.phone = _vm.registerinfo.phone.replace(
                            /[^\d]/g,
                            ""
                          )
                        }
                      ],
                      focus: function($event) {
                        return _vm.inpFocus()
                      },
                      blur: function($event) {
                        return _vm.inpBlur(1)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "register-item register-item-native" }, [
                  _c("span", { staticClass: "verification-icon" }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.registerinfo.verification,
                        expression: "registerinfo.verification"
                      }
                    ],
                    attrs: {
                      type: "tel",
                      placeholder: "验证码",
                      maxlength: "6"
                    },
                    domProps: { value: _vm.registerinfo.verification },
                    on: {
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.registerinfo,
                            "verification",
                            $event.target.value
                          )
                        },
                        function($event) {
                          _vm.registerinfo.verification = _vm.registerinfo.verification.replace(
                            /[^\d]/g,
                            ""
                          )
                        }
                      ],
                      focus: function($event) {
                        return _vm.inpFocus()
                      },
                      blur: function($event) {
                        return _vm.inpBlur()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm.countdown == 60
                    ? _c(
                        "span",
                        {
                          staticClass: "getverification-btn",
                          class: { "disabled-btn": !_vm.registerinfo.phone },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.getverification($event)
                            }
                          }
                        },
                        [_vm._v("获取验证码")]
                      )
                    : _c(
                        "span",
                        { staticClass: "getverification-btn disabled-btn" },
                        [_vm._v(_vm._s(_vm.countdown) + "s")]
                      )
                ]),
                _vm._v(" "),
                _c("div", { attrs: { id: "captcha" } }),
                _vm._v(" "),
                _c("div", { staticClass: "infor_agreement" }, [
                  !_vm.isChecked
                    ? _c("img", {
                        attrs: {
                          src: require("../assets/img/rankingimg/no-checked.png"),
                          alt: ""
                        },
                        on: {
                          click: function($event) {
                            _vm.isChecked = true
                          }
                        }
                      })
                    : _c("img", {
                        attrs: {
                          src: require("../assets/img/rankingimg/checked.png"),
                          alt: ""
                        },
                        on: {
                          click: function($event) {
                            _vm.isChecked = false
                          }
                        }
                      }),
                  _vm._v(" "),
                  _c("span", { staticClass: "infor_explain" }, [
                    _vm._v("注册即同意"),
                    _c("a", { on: { click: _vm.goregisterAgreement } }, [
                      _vm._v("用户协议及隐私政策")
                    ]),
                    _vm._v("，请仔细阅读说明")
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "confrim-btn-box" }, [
                  _c(
                    "div",
                    {
                      staticClass: "confrim-btn",
                      class: {
                        "disabled-confrim-btn":
                          !_vm.registerinfo.name ||
                          !_vm.registerinfo.phone ||
                          !_vm.registerinfo.verification ||
                          !_vm.isChecked
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: require("../assets/img/rankingimg/register-confrim1.png"),
                          alt: ""
                        },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.confrimregister($event)
                          }
                        }
                      })
                    ]
                  )
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "close-box" }, [
              _c("img", {
                attrs: {
                  src: require("../assets/img/rankingimg/close-icon.png"),
                  alt: ""
                },
                on: {
                  click: function($event) {
                    return _vm.closeboxBtn()
                  }
                }
              })
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _vm.firstFlag && _vm.acquisitionTime !== 3 && _vm.acquisitionTime !== 4
        ? _c("div", { staticClass: "msg" }, [
            _c("div", { staticClass: "msg-content" }, [_c("index-Msg")], 1),
            _vm._v(" "),
            _c("img", {
              staticClass: "close-msg",
              attrs: {
                src: require("../assets/img/rankingimg/close-icon.png"),
                alt: ""
              },
              on: {
                click: function($event) {
                  return _vm.closeMsg()
                }
              }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.guideFlag &&
                _vm.acquisitionTime !== 3 &&
                _vm.acquisitionTime !== 4,
              expression:
                "guideFlag && acquisitionTime !== 3 && acquisitionTime !== 4"
            }
          ],
          staticClass: "guide"
        },
        [
          _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.guideOne,
                expression: "guideOne"
              }
            ],
            staticClass: "img-one",
            attrs: { src: require("../assets/img/one.png"), alt: "" },
            on: {
              click: function($event) {
                return _vm.guideFn(1)
              }
            }
          }),
          _vm._v(" "),
          _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.guideTwo,
                expression: "guideTwo"
              }
            ],
            staticClass: "img-two",
            attrs: { src: require("../assets/img/two.png"), alt: "" },
            on: {
              click: function($event) {
                return _vm.guideFn(2)
              }
            }
          }),
          _vm._v(" "),
          _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.guideThree,
                expression: "guideThree"
              }
            ],
            staticClass: "img-three",
            attrs: { src: require("../assets/img/three.png"), alt: "" },
            on: {
              click: function($event) {
                return _vm.guideFn(3)
              }
            }
          }),
          _vm._v(" "),
          _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.guideFour,
                expression: "guideFour"
              }
            ],
            staticClass: "img-four",
            attrs: { src: require("../assets/img/four.png"), alt: "" },
            on: {
              click: function($event) {
                return _vm.guideFn(4)
              }
            }
          }),
          _vm._v(" "),
          _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.guideFive,
                expression: "guideFive"
              }
            ],
            staticClass: "img-five",
            attrs: { src: require("../assets/img/five.png"), alt: "" },
            on: {
              click: function($event) {
                return _vm.guideFn(5)
              }
            }
          })
        ]
      ),
      _vm._v(" "),
      _vm.acquisitionTime != 1 && _vm.acquisitionFlag
        ? _c("div", { staticClass: "acquisition-msg" }, [
            _c("div", { staticClass: "acquisition-contant" }, [
              _c("div", { staticClass: "acquisition-top" }, [
                _vm.acquisitionTime == 4
                  ? _c("img", {
                      attrs: {
                        src: require("../assets/img/hdnostart.png"),
                        alt: ""
                      }
                    })
                  : _vm.acquisitionTime == 3
                  ? _c("img", {
                      attrs: {
                        src: require("../assets/img/hdend.png"),
                        alt: ""
                      }
                    })
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "acquisition-text" }, [
                _c("p", [_vm._v("活动时间:")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(_vm._s(_vm.startTime) + "~" + _vm._s(_vm.endTime))
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "acquisition-close" }, [
              _c("img", {
                attrs: {
                  src: require("../assets/img/rankingimg/close-icon.png"),
                  alt: ""
                },
                on: {
                  click: function($event) {
                    _vm.acquisitionFlag = false
                  }
                }
              })
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "top-title-left" }, [
      _c("img", {
        attrs: { src: require("../assets/img/guangbo.png"), alt: "" }
      }),
      _vm._v(" "),
      _c("p", [_vm._v("福利通知:")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f795181", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f795181","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/index.vue
// module id = null
// module chunks = 